var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-container"},[(_vm.link.length==0)?_c('vcl-facebook',{staticStyle:{"margin":"20px"}}):_c('iframe',{staticClass:"responsive-iframe",attrs:{"src":_vm.link,"frameborder":"0"}}),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }